
import {
    Meh, Smile, ShieldAlert, Frown, HelpCircle, Zap
} from 'lucide-react';

// ---------------------------------------------------------------------------
// Form Select Options — single source of truth (used in Settings + Onboarding)
// ---------------------------------------------------------------------------

export const CARGO_OPTIONS = [
    'Fundador / CEO',
    'Diretor / C-Level',
    'Gerente / Coordenador',
    'Analista / Especialista',
    'Consultor / Freelancer',
    'Estudante',
    'Outro',
];

export const OBJETIVO_OPTIONS = [
    'Criar Personas para Marketing',
    'Treinamento de Equipe / Vendas',
    'Desenvolvimento de Produto',
    'Estudos sociológicos/pesquisa',
    'Outro',
];

/** Canonical values — must be consistent between Onboarding and Settings */
export const TAMANHO_OPTIONS = [
    'Apenas eu (Autônomo)',
    '1 a 10 funcionários',
    '11 a 50 funcionários',
    '51 a 200 funcionários',
    'Mais de 200 funcionários',
];

export const CONHECEU_OPTIONS = [
    'Google / Buscador',
    'Instagram / Facebook',
    'LinkedIn',
    'Recomendação de amigo',
    'YouTube',
    'TikTok',
    'Outro',
];

// ---------------------------------------------------------------------------
// Feature Flags
// ---------------------------------------------------------------------------
export const SHOW_CREATORS_FEATURE = false;




// ---------------------------------------------------------------------------
// Mood System
// ---------------------------------------------------------------------------

export const MOODS = [
    { id: 'neutro', label: 'Neutro / Calmo', icon: Meh, color: 'text-slate-600', bg: 'bg-slate-100' },
    { id: 'feliz', label: 'Feliz / Otimista', icon: Smile, color: 'text-emerald-600', bg: 'bg-emerald-100' },
    { id: 'cetico', label: 'Cético / Desconfiado', icon: ShieldAlert, color: 'text-amber-600', bg: 'bg-amber-100' },
    { id: 'irritado', label: 'Irritado / Estressado', icon: Frown, color: 'text-red-600', bg: 'bg-red-100' },
    { id: 'curioso', label: 'Curioso / Interessado', icon: HelpCircle, color: 'text-blue-600', bg: 'bg-blue-100' },
    { id: 'apressado', label: 'Apressado / Sem Tempo', icon: Zap, color: 'text-violet-600', bg: 'bg-violet-100' },
];

